import React from 'react';
import '../../../css/Form.css';
import Select from 'react-select';
// import ImagesPopup from '../../../helper/ImagesPopup';
import UploadFile from '../../../helper/UploadFile';

const OtherEducation = (props) => {
	const {
		addComponent,
		GenerateRemovePopup,
		others,
		userDetails,
		setUserDetails,
		// EducationDetailsHandler,
		EducationOtherDetailsHandler,
		EducationalDetailsDropDownHandler,
		YearsDropDownData,
		EducationStatus,
		// onFileChange,
		// imageRemoveHandler,
		// openImageInTab,
		checkDecimal,
		UploadData,
		setSaveTheData
	} = props;

	//UPLOAD COMPONENT DATA SETTING
	const uploadProcessCode = "EMPLOYEE_APP_EDN_OTHERS";
	const processCodeData= UploadData.filter((item)=>item.uploadProcessCode===uploadProcessCode)

	// const [openView, setOpenView] = useState({
	// 	popupOpen: false,
	// 	currentIndex: null
	// });

	// const popupHandler = (event) => {
	// 	var oldObj = { ...openView };
	// 	oldObj.popupOpen = true;
	// 	oldObj.currentIndex = event.target.id;
	// 	setOpenView(oldObj);
	// };

	// const ClosePopup = () => {
	// 	var oldObj = { ...openView };
	// 	oldObj.popupOpen = false;
	// 	setOpenView(oldObj);
	// };

	const getUploadData = (data, index) => {
		let newState = { ...userDetails };
		newState.others[index].Documents = data
		setUserDetails(newState);
		setSaveTheData(true)
	};

	return (
		<div className="col-12">
			{others.map((el, index) => {
				return (
					<div key={index} className="animated zoomIn container-fluid">
						<div className="row p-1">
							<div className="col-md-3">
								<label className="formRenderlabel ">
									Qualification
								</label>
								<input
									className="form-control z-depth-3"
									value={el.otherQualification}
									type="text"
									name="otherQualification"
									onChange={(e) => EducationOtherDetailsHandler(
										e,
										index,
									)}
									id={index + 'otherQualification'}
									title="others"
									maxLength="50"
								/>
							</div>
							<div className="col-md-3">
								<label className="formRenderlabel ">
									Status
								</label>
								<Select
									className='z-depth-3'
									value={el.otherStatus}
									onChange={(selected) =>
										EducationalDetailsDropDownHandler(
											selected,
											index,
											'otherStatus',
											'others',
											'otherStatus',
											'otherPercentage'
										)}
									options={EducationStatus}
								/>
							</div>
							<div className="col-md-3">
								<label className="formRenderlabel ">
									Course
								</label>
								<input
									className="form-control z-depth-3"
									value={el.otherCourse}
									type="text"
									name="otherCourse"
									onChange={(e) => EducationOtherDetailsHandler(
										e,
										index,
									)}
									id={index + 'otherCourse'}
									title="others"
									maxLength="100"
								/>
							</div>
							<div className="col-md-3">
								<label className="formRenderlabel ">
								Specialisation
								</label>
								<input
									className="form-control z-depth-3"
									value={el.otherSpecialization}
									type="text"
									name="otherSpecialization"
									onChange={(e) => EducationOtherDetailsHandler(
										e,
										index,
									)}
									id={index + 'otherSpecialization'}
									title="others"
									maxLength="100"
								/>
							</div >
						</div >
						<div className="row p-1">
							<div className="col-md-3">
								<label className="formRenderlabel ">
									{el.otherStatus.label === 'Pursuing' ? (
										'Year of Registration'
									) : (
										'Year of Completion'
									)}
								</label>
								<Select
									classNameName="formSelect z-depth-3"
									value={el.otherYearOfComp}
									onChange={(selected) =>
										EducationalDetailsDropDownHandler(selected, index, 'otherYearOfComp', 'others')}
									options={YearsDropDownData}
								/>
							</div>

							<div className="col-md-3">
								<label className="formRenderlabel ">
									{el.otherStatus.label === 'Pursuing' ? 'Current status' : 'Grade/Percentage'}
								</label>
								<input
									className="form-control z-depth-3"
									value={el.otherPercentage}
									type='text'
									name="otherPercentage"
									onChange={(event) => EducationOtherDetailsHandler(event, index,"grade"
										// el.otherStatus.label === 'Pursuing' ? 'text' : 'number'
										)}
									id={index + 'otherPercentage'}
									title="others"
									maxLength="50"
									onBlur={() => el.otherStatus.label === 'Pursuing' ? '' : (event) => checkDecimal(event, '')}
								/>
							</div >
							<div className="col-md-3">
								<label className="formRenderlabel ">
									Institute
								</label>
								<input
									className="form-control z-depth-3"
									value={el.otherInstitute}
									type="text"
									name="otherInstitute"
									onChange={(e) => EducationOtherDetailsHandler(
										e,
										index,
									)}
									id={index + 'otherInstitute'}
									title="others"
									maxLength="100"
								/>
							</div >
							<div className="col-md-3">
								<label className="formRenderlabel ">
									Board/University
								</label>
								<input
									className="form-control z-depth-3"
									value={el.otherBoard}
									type="text"
									name="otherBoard"
									onChange={(e) => EducationOtherDetailsHandler(
										e,
										index,
									)}
									id={index + 'otherBoard'}
									title="others"
									maxLength="100"
								/>
							</div >
							<div className="col-md-5">
								<label className="formRenderlabel ">
									Document
									<span className='upload-accepted-format-indication'>({processCodeData[0]?.fileTypeList.join(',')})</span>
								</label>
								<UploadFile
									callback={getUploadData}
									data={el?.Documents}
									isMulti
									keyList={processCodeData}
									id={uploadProcessCode}
									otherParams={index}
								/>
								<br/>
												<span className='upload-accepted-format-indication'>File size limit: less than 1024kb</span>
								{/* <label className="educationUpload">
									<input
										type="file"
										style={{ display: 'none' }}
										onChange={(event) => onFileChange(event, 'others')}
										// accept="image/*"
										id={index}
										multiple
									/>[ <i className="fa fa-upload uploadIcon" aria-hidden="true"></i> Upload ]
								</label>
								<label className="educationUpload">
									<input
										type="button"
										style={{ display: 'none' }}
										onClick={popupHandler}
										id={index}
									/>{' '}
									[ <i className="fa fa-eye uploadIcon" aria-hidden="true"></i> view ]
								</label> */}
							</div >
							{index >= 0 ? (
								<div className="col-md-7">
									<button
										type="button"
										className="RemoveLinkButton pull-right"
										onClick={() =>
											GenerateRemovePopup('EducationPopup', index, 'Education', 'others')}
										id={index}
									>
										<i className="fa fa-trash RemoveIcon" />
										Remove
									</button>
								</div>
							) : null}
						</div >
					</div >
				);
			})}
			<div className="">
				<div className="row p-1">
					<div className="col-md-12 d-flex justify-content-end">
						<button
							type="button"
							className="OtherFormLinkButton"
							onClick={() => addComponent('Education', 'others')}
						>
							<span className="fa fa-plus formAddIcon" />Add More (Additional Qualification)
						</button>
					</div>
				</div>
			</div>
			{/* {
				openView.popupOpen ? (
					<ImagesPopup
						open={openView.popupOpen}
						close={ClosePopup}
						Imgdata={others}
						imageRemoveHandler={imageRemoveHandler}
						currentIndex={openView.currentIndex}
						compName="others"
						isFromEducation={false}
						openImageInTab={openImageInTab}
					/>
				) : null
			} */}
		</div >
	);
};

export default OtherEducation;
